import React from 'react';
import { Grid } from '@material-ui/core';

export default function PageLandingMessage(props){
    let buttonName = (props?.buttonName || '') !== '' ? props?.buttonName : 'Run Report';
    return(
        <Grid container spacing={4}>
            <Grid
                container
                direction="row-reverse"
                justify="center"
                alignItems="stretch"
            >
                <label className="item-big">Click on <b>{buttonName}</b> button to view data</label>
            </Grid>
        </Grid>
    );
}